const styles = {
    firstLine: {
        color:"#819999",
        fontWeight: "400",
        textAlign: "left",
        fontSize: "78%",
        lineHeight: "11px",
        marginBottom: "3px"
    },
    secondLine: {
        color: "#06844D",
        textAlign: "left",
        fontSize: "100%",
        lineHeight: "14px",
        fontWeight: "bold"
    },
    wrapper: {
        paddingLeft: "4.53vw",
    }
}

export default styles;